<div class="card-menu-container">
  <p-menubar [model]="items" [style]="{ 'background-color': '#607D8B' }"></p-menubar>
</div>
